import React from "react";
import { Loader2 } from "lucide-react";

export function MobileCards({ items, loading, empty = "Nenhum registro.", render, testid = "mobile-cards" }) {
  return (
    <div className="lg:hidden space-y-3 min-w-0" data-testid={testid}>
      {loading ? <div className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin gold-text mx-auto" /></div>
        : items.length === 0 ? <div className="trt-card py-8 text-center text-slate-400">{empty}</div>
        : items.map(render)}
    </div>
  );
}

export const Row = ({ l, v, className = "" }) => (
  <div className={`min-w-0 ${className}`}><div className="text-xs text-slate-400">{l}</div><div className="break-words">{v ?? "—"}</div></div>
);
